import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { UpdateEmailCriteria } from "src/app/models/auth";
import { FormValidationService } from "src/app/services/form-validation.service";
import { MemberService } from "src/app/services/member.service";

@Component({
    selector: 'mwp-registered-email',
    templateUrl: './registered-email.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogRegisteredEmailComponent {

    public registeredEmailForm: FormGroup;

    constructor(
        private formBuilder: FormBuilder,
        private dialogRef: MatDialogRef<DialogRegisteredEmailComponent>,
        private memberService: MemberService,
    ) {
    }

    ngOnInit(): void {
        this.registeredEmailForm = this.formBuilder.group({
            newEmail: [null, [Validators.required, Validators.compose([FormValidationService.validEmail(), FormValidationService.validMatchingValue('newEmailConfirm', true)])]],
            newEmailConfirm: [null, [Validators.required,Validators.compose([FormValidationService.validMatchingValue('newEmail')])]],
        });
    }

    save(): void {
        const l_UpdateEmailCriteria = new UpdateEmailCriteria();
        l_UpdateEmailCriteria.newEmail = this.registeredEmailForm.get('newEmail').value;
        l_UpdateEmailCriteria.newEmailConfirm = this.registeredEmailForm.get('newEmailConfirm').value;

        this.memberService.saveRegistredEmail(l_UpdateEmailCriteria).subscribe(() => {
            this.dialogRef.close(true);
        });
    }

    close(): void {
        this.dialogRef.close();
    }
}